// extracted by mini-css-extract-plugin
export default {"container":"Auth_container__6WoUr","form":"Auth_form__eGfRn","field":"Auth_field__Z6pKm","submitButton":"Auth_submitButton__rctfj","link":"Auth_link__ie7v5"};